import { combineReducers } from "@reduxjs/toolkit"
import BoutiqueReducer from "./boutiqueReducers/boutiqueSlice"
import CashRegisterReducer from "./cashRegisterReducers/cashRegisterSlice"
import GlobalReducer from "./globalReducer/globalSlice"
import ModalReducer from "./modalsReducers/modalSlice"
import PromotionReducer from "./promotionReducers/promotionSlice"
import SnackbarReducer from "./snackbarReducers/snackbarSlice"
import UnavailabilityShopReducer from "./unavailabilityReducers/unavailabilityShopSlice"

const rootReducer = combineReducers({
  global: GlobalReducer,
  modal: ModalReducer,
  boutique: BoutiqueReducer,
  promotion: PromotionReducer,
  unavailabilityShop: UnavailabilityShopReducer,
  snackbar: SnackbarReducer,
  cashRegister: CashRegisterReducer,
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
